import cx from 'classnames';
import i18n from '@remind/i18n';
import React from 'react';
import { debounce } from 'lodash';

import AsyncSelect from 'components/AsyncSelect.jsx';
import AsyncSelectItem from 'components/AsyncSelectItem.jsx';
import CurrentUser from 'auth/CurrentUser';
import EventTracking from 'lib/EventTracking.js';
import Link from 'components/Link.jsx';
import OrganizationActions from 'actions/OrganizationActions';
import OrganizationCreateModal from 'organizations/components/OrganizationCreateModal.jsx';
import OrganizationProfiles from 'collections/OrganizationProfiles';
import Organizations from 'collections/Organizations';
import Organization from 'entities/Organization';
import SchoolColleaguesRow from 'components/SchoolColleaguesRow.jsx';
import SettingsStore from 'stores/SettingsStore';
import { NO_SCHOOL, OrganizationTypes } from 'constants/OrganizationConstants';
import { mountModal } from 'lib/modal';

const ORGANIZATIONS_PAGE_SIZE = 20;

const CREATE_SCHOOL_ITEM = -1;
const DEBOUNCE_DELAY = 300;

import './styles/SchoolPicker.scss';

// TODO rename to OrganizationPicker
const SchoolPicker = React.createClass({
  propTypes: {
    onSelect: React.PropTypes.func.isRequired,
    onClear: React.PropTypes.func.isRequired,
    schoolId: React.PropTypes.number,
    selectedSchool: React.PropTypes.instanceOf(Organization),
    onCreateOrganization: React.PropTypes.func,
    onNoSchool: React.PropTypes.func,
    suggestions: React.PropTypes.oneOfType([
      React.PropTypes.instanceOf(Organizations),
      React.PropTypes.arrayOf(React.PropTypes.instanceOf(Organization)),
    ]),
    noQuery: React.PropTypes.string,
    filterSearchResults: React.PropTypes.func,
    organizationType: React.PropTypes.oneOf(Object.keys(OrganizationTypes)),
    showNCESId: React.PropTypes.bool,
  },

  contextTypes: {
    eventScreenName: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      organizationType: OrganizationTypes.SCHOOL,
    };
  },

  getInitialState() {
    const user = CurrentUser.getUser();
    // why do we need to test `user.worksAtASchool()` when `this.props.schoolId` says NO_SCHOOL?
    const noSchool = user && (user.worksAtASchool() === false)
      && (this.props.schoolId === NO_SCHOOL.id);
    return {
      defaultSchool: noSchool ? NO_SCHOOL : null,
      allPotentialSchoolsLoaded: false,
      loadedSchools: [],
      query: '',
    };
  },

  componentWillMount() {
    if (this.props.selectedSchool) {
      this.setState({ defaultSchool: this.props.selectedSchool });
    }
  },

  componentDidMount() {
    if (this.props.schoolId && !this.state.defaultSchool) {
      OrganizationActions.getOrLoadOrganization(this.props.schoolId).then((school) => {
        this.setState({ defaultSchool: school });
      });
    }
  },

  onClear() {
    this.setState(this.getInitialState(), this.props.onClear);
  },

  onCreateOrganization(organization) {
    OrganizationActions.addOrganization(organization);
    if (this.isMounted()) {
      this.setState({ defaultSchool: organization }, () => {
        this.props.onCreateOrganization(organization);
      });
    } else {
      this.props.onCreateOrganization(organization);
    }
    EventTracking.tap(
      this.context.eventScreenName,
      'SchoolPicker-createSchool',
      '',
      { query: this.state.query },
    );
  },

  onNoSchool() {
    EventTracking.tap(
      this.context.eventScreenName,
      'dontWorkButton',
      '',
      { query: this.state.query },
    );
    this.setState({ defaultSchool: NO_SCHOOL }, () => {
      if (typeof this.props.onNoSchool !== 'undefined') {
        this.props.onNoSchool();
      }
    });
  },

  onSearchCallback: debounce(function(query, callback) {
    if (!query) {
      return callback(new Promise(resolve => resolve([])));
    }
    EventTracking.tap(
      this.context.eventScreenName,
      'SchoolPicker-search'
    );
    while (this.state.allPotentialSchoolsLoaded !== true) {
      return this.performSearch(query, callback);
    }
  }, DEBOUNCE_DELAY),

  onSelect(item) {
    if (!item.props) {
      return;
    }
    const key = item.props.id;
    this.setState({ defaultSchool: null });

    if (key === CREATE_SCHOOL_ITEM) {
      mountModal(this.getOrganizationCreateModal(), this);
    } else {
      if (key === NO_SCHOOL.id && this.props.onNoSchool) {
        this.onNoSchool();
      }
      this.props.onSelect(key, item.props.title);
    }
    EventTracking.tap(
      this.context.eventScreenName,
      'SchoolPicker-select',
      { key }
    );
  },

  getOrganizationCreateModal() {
    return (
      <OrganizationCreateModal
        onCreate={this.onCreateOrganization}
        defaultOrganization={this.refs.schools.getSearchString()}
        organizationType={this.props.organizationType}
      />
    );
  },

  getSearchRequest(query) {
    const source = CurrentUser.isSignedIn() ? Organizations : OrganizationProfiles;

    const numLoaded = this.state.loadedSchools.length;
    const page = Math.floor(numLoaded / ORGANIZATIONS_PAGE_SIZE) + 1;

    return source.search(this.props.organizationType, query, page);
  },

  focus() {
    this.refs.schools.focus();
  },

  performSearch(query, callback) {
    callback(this.getSearchRequest(query).then((organizations) => {
      const filteredOrgs = this.props.filterSearchResults ?
        this.props.filterSearchResults(organizations.toArray()) :
        organizations;

      const schools = this.state.loadedSchools;

      if (filteredOrgs.length < ORGANIZATIONS_PAGE_SIZE) {
        this.setState({ allPotentialSchoolsLoaded: true });
      }

      filteredOrgs.forEach(function(organization) {
        schools.push(organization);
        OrganizationActions.addOrganization(organization);
      });
      this.setState({ query, loadedSchools: schools });

      return schools.map(this.renderItemFromSchool);
    }));
  },

  initialItems() {
    return this.props.suggestions && this.props.suggestions.map(this.renderItemFromSchool);
  },

  permanentItems() {
    const permanentItems = [];

    // If there's no callback to the create school
    // then we don't show the last permanent result.
    if (this.props.onCreateOrganization) {
      permanentItems.push(
        <AsyncSelectItem id={CREATE_SCHOOL_ITEM} title="">
          <div className="SchoolPicker-item SchoolPicker-item--perma SchoolPicker-new">
            Can’t find your {this.props.organizationType.toLowerCase()}?
            {' '}
            <Link weight="semibold">Add it now</Link>
          </div>
        </AsyncSelectItem>
      );
    }

    if (this.props.onNoSchool) {
      permanentItems.push(
        <AsyncSelectItem id={NO_SCHOOL.id} title={NO_SCHOOL.getName()}>
          <div className="SchoolPicker-item SchoolPicker-item--perma SchoolPicker-none">
            <Link weight="semibold">I don’t work at a school</Link>
          </div>
        </AsyncSelectItem>
      );
    }

    return permanentItems;
  },

  renderItemFromSchool(organization) {
    if (organization === NO_SCHOOL) {
      return this.renderNoSchool();
    }

    const address = organization.getFormattedAddress();

    const body = (
      <div className="SchoolPicker-item">
        <div className="SchoolPicker-item-title">
          {organization.getName()}
        </div>
        <div className="SchoolPicker-item-body">
          <address>
            {address}
          </address>
          <div>
            {this.props.showNCESId
              ? organization.getNCESId() && 'NCES ID: ' + organization.getNCESId()
              : <SchoolColleaguesRow school={organization} />}
          </div>
        </div>
      </div>
    );

    return (
      <AsyncSelectItem id={organization.id} title={organization.getName()}>
        {body}
      </AsyncSelectItem>
    );
  },

  renderNoSchool() {
    const body = (
      <div className="SchoolPicker-item">
        <div className="SchoolPicker-item-title">
          {NO_SCHOOL.getName()}
        </div>
      </div>
    );

    return (
      <AsyncSelectItem id={NO_SCHOOL.id} title={NO_SCHOOL.getName()}>
        {body}
      </AsyncSelectItem>
    );
  },

  render() {
    const { className, ...others } = this.props;
    const minQuery = SettingsStore.getMinimumOrgQueryLength();

    let schoolItem;
    if (this.state.defaultSchool) {
      schoolItem = this.renderItemFromSchool(this.state.defaultSchool);
    }

    return (
      <div className={cx('SchoolPicker', className)}>
        <div className="SchoolPicker-AsyncWrapper">
          <AsyncSelect
            {...others}
            ref="schools"
            clearOnInputChange
            infiniteLoad
            inputDelay={500}
            defaultItem={schoolItem}
            initialItems={this.initialItems()}
            searchCallback={this.onSearchCallback}
            onSelect={this.onSelect}
            onClear={this.onClear}
            permanentItems={this.permanentItems()}
            queryMinSize={minQuery}
            noQuery={this.props.noQuery}
            queryTooShort={i18n.getText(
              'Enter a minimum of {minQuery, plural, one {# character} other {# characters}}' +
              ' to search for your school',
              { minQuery }
            )}
          />
        </div>
      </div>
    );
  },
});

export default SchoolPicker;



// WEBPACK FOOTER //
// ./src/components/SchoolPicker.jsx